import React, { useState, useEffect, createContext } from 'react';

export const UserContext = createContext();

const UserProvider = ({ children }) => {
    const [data, setData] = useState({
        logger: !!localStorage.getItem('delphireact-token'),
        userRole: localStorage.getItem('user-role') || null,
    });

    const [theme, setTheme] = useState(
        () => localStorage.getItem('cs-theme') || 'light'
    );

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('cs-theme', theme);
    }, [theme]);

    const isLogger = data.logger;
    const userRole = data.userRole;

    const alterLogin = (value, role = null) => {
        setData({ ...data, logger: value, userRole: role });
    };

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
    };

    return (
        <UserContext.Provider value={{ isLogger, userRole, alterLogin, theme, toggleTheme }}>
            {children}
        </UserContext.Provider>
    );
};

export default UserProvider;
